import {useLazyQuery, useMutation} from '@apollo/client'
import React, {useEffect, useState, useRef} from 'react'
import {
  GET_DO_NOT_ENROLL,
  REMOVE_DO_NOT_ENROLL,
  GET_CLIENT_ALLOWED_COMPONENTS,
} from '../../../../utils/GraphQLAPI'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {CreateMemberModal} from './CreateMemberModal'
import {UploadMemberModal} from './UploadMemberModal'
import uploadIcon from '../../../../_metronic/images/upload.svg'
import DownloadCsv from '../../Download/DownloadCsv'
import './DoNotEnroll.css'

import SearchList from '../../../sharedComponent/SearchList/SearchList'
import {DNELISTCONFIGS} from '../../../../utils/TeamAdmin/DonotEnroll'
import {dropdownMenuItemsType} from '../../../sharedComponent/SearchList/SearchList.types'
import {areYouSurePrompt} from '../../../../utils/helper'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import {DownloadTemplate} from '../../../sharedComponent/DownloadTemplate/DownloadTemplate'

const MySwal = withReactContent(Swal)

const DoNotEnrollList = () => {
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [showCreateUploadModal, setShowCreateUploadModal] = useState<boolean>(false)
  const [createModal, setCreateModal] = useState<string>('create')
  const [addMethod, setAddMethod] = useState<string>('')
  const [editId, setEditId] = useState<string>('')
  const [csv, setCsv] = useState<boolean>(false)
  const [filterTempOptions, setFilterTempOptions] = useState<any>()
  const [downloadData, setDownloadData] = useState<any>([])
  const [rerender, setRerender] = useState(false)
  const [isSolarProduct, setIsSolarPRoduct] = useState<any>(false)
  const [getClientAllowedComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setIsSolarPRoduct(data?.getClientAllowedComponents.includes('solarProductSetup'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  useEffect(() => {
    getClientAllowedComponents()
  }, [])
  const csvRef = useRef<any>(null)

  const [filterOptions, setFilterOptions] = useState<any>({
    searchText: '',
    page: 1,
    perPage: 10,
  })

  // List API
  const [getDoNotEnrollList, {loading, data: doNotEnrollList, refetch}] = useLazyQuery(
    GET_DO_NOT_ENROLL,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      variables: {
        dneListInput: filterOptions,
      },
    }
  )

  useEffect(() => {
    getDoNotEnrollList()
  }, [filterOptions])

  // DNE List Download API  Hit
  const [getDoNotEnrollCSVList, {loading: reload}] = useLazyQuery(GET_DO_NOT_ENROLL, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      dneListInput: filterTempOptions,
    },
    onCompleted: (data) => {
      setDownloadData(data.getDneList.dnes)
    },
    onError: (err) => console.log('error', err),
  })

  // Manual
  const openModal = (editIdValue: any) => {
    setShowCreateAppModal(true)
    setShowCreateUploadModal(false)
    setCreateModal('create')
    setAddMethod(addMethod)
    setEditId(editIdValue)
  }

  const handleCloseModal = () => {
    refetch()
    setShowCreateAppModal(false)
    setAddMethod('')
    setEditId('')
  }

  // Upload
  const openUploadModal = () => {
    setShowCreateUploadModal(true)
    setShowCreateAppModal(false)
    setCreateModal('create')
    setAddMethod(addMethod)
    setRerender(false)
  }

  const handleCloseUploadModal = () => {
    refetch()
    setShowCreateUploadModal(false)
    setAddMethod('')
  }

  const refetchList = () => {
    refetch()
  }

  //Remove
  const [deleteDne] = useMutation(REMOVE_DO_NOT_ENROLL, {
    onCompleted: () => {
      refetch()
      MySwal.fire({
        title: 'Deleted!',
        text: 'Your data has been deleted.',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      })
    },
  })

  const removeDne = async (id: any) => {
    areYouSurePrompt(
      'Are you sure?',
      () => {
        deleteDne({
          variables: {
            id: id,
          },
        })
      },
      () => {},
      'Yes, delete it',
      'No, cancel !'
    )
  }

  //DNE List Download
  const csvHeaders = [
    {label: 'Phone Number', key: 'phoneNumber'},
    {label: 'Utility Account Number', key: 'utilityAccountNumber'},
    {label: 'Zip', key: 'zipCode'},
  ]

  useEffect(() => {
    const {page, perPage, ...rest} = filterOptions
    setFilterTempOptions(rest)
    setCsv(false)
  }, [])

  const csvDownloadFun = async () => {
    await getDoNotEnrollCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  const dropdownMenuItems: dropdownMenuItemsType[] = [
    {
      name: 'Preview',
      callBack: openModal,
    },
    {
      name: 'Delete',
      callBack: removeDne,
      textColor: 'text-danger',
    },
  ]
  const handleFilterOptions = DNELISTCONFIGS.filter(
    (item) => isSolarProduct || item.headerName !== 'Email'
  )

  return (
    <>
      <Breadcrumbs title='Do Not Enroll List' subTitle='Home - Do Not Enroll' />
      <SearchList
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        listConfigs={handleFilterOptions}
        listCount={doNotEnrollList?.getDneList?.totalCount}
        paginatedCount={doNotEnrollList?.getDneList?.dnes?.length}
        listLoading={loading}
        apiData={doNotEnrollList?.getDneList?.dnes}
        idFieldName='id'
        toolbar={
          <div className='m-0'>
            {doNotEnrollList?.getDneList?.totalCount !== 0 && (
              <DownloadCsv
                csvDownloadFun={csvDownloadFun}
                reload={reload}
                csvHeaders={csvHeaders}
                csvRef={csvRef}
                downloadData={downloadData}
                downloadFileName='DoNotEnroll.csv'
              />
            )}

            <DownloadTemplate
              href={process.env.REACT_APP_DNE_TEMPLATE_DOWNLOAD}
              text='Download Template'
            />

            <button
              className='btn btn-light-primary btn-active-light-primary fw-bold fs-base ms-4'
              onClick={(e) => openUploadModal()}
            >
              <img src={uploadIcon} alt='' className='hover-white svg-icon svg-icon-1' />
              Upload List
            </button>

            <UploadMemberModal
              show={showCreateUploadModal}
              handleClose={handleCloseUploadModal}
              refetchList={refetchList}
              method={createModal}
              setRerender={setRerender}
              rerender={rerender}
            />

            <button
              className='btn btn-primary fs-6 p-3 w-142px h-43px ms-4'
              onClick={(e) => openModal('')}
              type='button'
            >
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
              <span>Add Customer</span>
            </button>

            <CreateMemberModal
              isSolarProduct={isSolarProduct}
              show={showCreateAppModal}
              handleClose={handleCloseModal}
              refetchList={refetchList}
              method={createModal}
              editId={editId}
            />
          </div>
        }
        dropdownMenuItems={dropdownMenuItems}
        isActiveApiFieldName=''
      />
    </>
  )
}
export default DoNotEnrollList
